module.exports = __webpack_public_path__ + "img/17239671_10210358765958834_7990198028082071779_o.eca72da5.jpg";